// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__D+kzf","intro":"Banner_intro__idijb","image":"Banner_image__pqBaq"};